import { Loader2, Search, SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export function ApprovalRequestsToolbar({
  searchValue,
  onSearchChange,
  onFilterClick,
  filterCount = 0,
  filterOpen = false,
  isSearching = false,
}) {
  return (
    <div className="page-toolbar shrink-0">
      {/* Selecting and clearing are not toolbar concerns: the header checkbox
          already selects and deselects the page, and the selection bar carries
          Clear beside the actions it applies to. Two more buttons for the same
          two operations left the row with controls that were dead most of the
          time — nothing is selected when the page loads — and put "Clear
          selection" a long way from the selection it cleared. Every other queue
          in the app already works this way. */}
      <div className="flex flex-col gap-3 px-4 py-2.5 sm:px-5 lg:flex-row lg:items-center">
        <div className="flex flex-1 shrink-0 items-center justify-end gap-4">
          <div className="relative min-w-0 flex-1 sm:w-64 sm:flex-none">
            {isSearching ? (
              <Loader2
                className="pointer-events-none absolute top-1/2 start-3 size-3.5 -translate-y-1/2 animate-spin text-muted-foreground"
                aria-hidden="true"
              />
            ) : (
              <Search
                className="pointer-events-none absolute top-1/2 start-3 size-3.5 -translate-y-1/2 text-muted-foreground"
                aria-hidden="true"
              />
            )}
            <Input
              type="search"
              value={searchValue}
              onChange={(event) => onSearchChange(event.target.value)}
              placeholder="Search approval requests"
              aria-label="Search approval requests"
              maxLength={80}
              className="h-11 rounded-[0.8rem] border-line bg-card ps-9 text-base shadow-none md:h-9 md:text-sm"
            />
          </div>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={onFilterClick}
            aria-haspopup="dialog"
            aria-expanded={filterOpen}
            className={cn(
              "h-11 shrink-0 rounded-[0.8rem] border-line px-3 shadow-none md:h-9",
              filterCount > 0 && "border-primary bg-primary text-primary-foreground",
            )}
          >
            <SlidersHorizontal data-icon="inline-start" />
            Filter
            {filterCount > 0 && (
              <span className="num ms-1 text-xs tabular-nums">({filterCount})</span>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
